import { type Option } from '@avanta/shared/components/ui/Select';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useEffect } from 'react';
import { type SetValueConfig } from 'react-hook-form';
import { useFetchEnterpriseContracts } from 'hooks/useFetchEnterpriseContracts';

type SelectIds = (name: 'contractIds', value: string[], options?: SetValueConfig) => void;

export const useGetContractsOptions = (
  setValue: SelectIds,
  selectedContractIds: string[] | undefined
): { contractIds: Option[] } => {
  const { data: contracts } = useFetchEnterpriseContracts();
  const contractOptions =
    contracts?.map(contract => ({
      value: String(contract.id),
      label: contract.title,
      description: contract.tenderNumber,
      ns: LOCIZE_NS.INSURANCE,
    })) ?? [];
  const singleContractId = contractOptions.length === 1 ? contractOptions[0].value : undefined;

  useEffect(() => {
    if (!singleContractId || (selectedContractIds?.length ?? 0) > 0) return;
    setValue('contractIds', [singleContractId], { shouldDirty: true, shouldValidate: true });
  }, [selectedContractIds, setValue, singleContractId]);

  return {
    contractIds: contractOptions,
  };
};
